import script from "./StaffFile.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffFile.vue?vue&type=script&setup=true&lang=js"

import "./StaffFile.vue?vue&type=style&index=0&id=0d2298f4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2298f4"]])

export default __exports__